
import sysConfig from "../config/sysConfig.js";
import { isObject } from "util";
import storage from "../tools/storage.js";
var smsService = {
  getSmsValidCode: function getSmsValidCode(params) {
    params = params || {};
    return sysConfig.$syscfg.K_Request("W0000108", params).then(function (data) {
      var obj = null;
      if (data.Code == "0") {
        obj = data.Data && {
          SEND_FLAG: "1"
        };
      }
      return obj;
    });
  },
  sendSmsMsg: function sendSmsMsg(params) {
    return sysConfig.$syscfg.K_Request("F0000041", params).then(function (res) {
      var obj = null;
      if (res.Code == "0") {
        return res.Data[0] || {};
      }
    });
  },
  checkUpValidCode: function checkUpValidCode(params) {
    params = params || {};
    return sysConfig.$syscfg.K_Request("W0000109", params).then(function (data) {
      var obj = null;
      if (data.Code == "0") {
        obj = data.Data && data.Data[0];
      }
      return obj;
    });
  },
  sendSMS: function sendSMS(params) {
    params = params || {};
    return sysConfig.$syscfg.K_Request("W0000110", params).then(function (data) {
      var obj = null;
      if (data.Code == "0") {
        obj = data.Data && data.Data[0];
      }
      return obj;
    });
  }
};

export default smsService;


//////////////////
// WEBPACK FOOTER
// ./src/service/sms-service.js
// module id = 207
// module chunks = 2